import React, { memo, useEffect, useState } from 'react';

import { Alert, App, Button, Modal, Typography } from 'antd';

import { useMutation } from '@tanstack/react-query';
import apiService from 'v2/services/api';

export interface ModalNewsRVPProps {
  available?: boolean;
}

export const ModalNewsRVP = memo(({ available }: ModalNewsRVPProps) => {
  const { message } = App.useApp();
  const [opened, setOpened] = useState(false);

  const disabledInThisSession = !!sessionStorage.getItem('disabled-products-without-rvp');

  const activate = useMutation({
    mutationFn: () => apiService.put('/products-without-rvp/activate', {}).toPromise(),
    onSuccess: () => {
      message.success('Ativação realizada com sucesso!');
      setOpened(false);
    },
    onError: () => {
      message.error('Não foi possível ativar o RVP.');
    }
  });

  const handleActivate = () => {
    activate.mutate();
  };

  const handleClose = () => {
    sessionStorage.setItem('disabled-products-without-rvp', 'true');
    setOpened(false);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  return (
    <Modal
      open={opened && available && !disabledInThisSession}
      onCancel={handleClose}
      maskClosable={false}
      title='Temos uma ferramenta poderosa e totalmente gratuita para você aproveitar!'
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={handleClose} disabled={activate.isPending}>
            Quero ativar mais tarde
          </Button>
          <Button type='primary' onClick={handleActivate} loading={activate.isPending}>
            Sim, ativar RVP!
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Alert
          type='info'
          showIcon
          message='Recuperação de Vendas Perdidas (RVP)'
          description={
            <>
              Já está disponível para você, mas ainda não está ativa em seus produtos. Recupere vendas não finalizadas e
              aumente sua conversão em até <Typography.Text strong>15%</Typography.Text> sem esforço!
            </>
          }
        />
        <Typography.Paragraph className='mb-0'>
          <Typography.Text strong>Que tal ativar agora?</Typography.Text>
        </Typography.Paragraph>
        <Typography.Text type='secondary' italic>
          Você pode alterar essa configuração a qualquer momento na edição de cada produto.
        </Typography.Text>
      </div>
    </Modal>
  );
});
